export default __webpack_public_path__ + "static/avatar-fd47faa230d35fb5405e9ca53a338ddb.png";